import React from 'react';
const XIcon = (props) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", ...props },
        React.createElement("path", { d: "M1 25L24.9725 1.00002M25 25L1.02746 1", stroke: "#0B2240", "stroke-width": "2" })));
};
export { XIcon };
